import unNotifyMe from "../../../../services/backInStock/unNotifyMe";
import { showSuccessBanner } from "../../../modules/savedItems/actions/notifyMe/showSuccessBanner";
import { SUCCESS_BANNER_OPT_OUT_ALERT } from "../../savedItems/constants";

export const disableAlert =
  ({ variantId }) =>
  dispatch => {
    dispatch(
      showSuccessBanner({ confirmationType: SUCCESS_BANNER_OPT_OUT_ALERT })
    );
    unNotifyMe({ variantId });
  };
